export default __webpack_public_path__ + "static/media/bg.e879f046.png";